export default __webpack_public_path__ + "static/media/icon-lightning-circle.28272ead.svg";